import { render, staticRenderFns } from "./BigNumbers.vue?vue&type=template&id=04a85789&scoped=true"
import script from "./BigNumbers.vue?vue&type=script&lang=js"
export * from "./BigNumbers.vue?vue&type=script&lang=js"
import style0 from "./BigNumbers.vue?vue&type=style&index=0&id=04a85789&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a85789",
  null
  
)

export default component.exports